@if (showSpinner) {
<app-spinner></app-spinner>
}

<div class="inner-page-header">
  <h3> {{pageTitle}} </h3>
</div>
<div class="request-control" #goUp>
  <div class="right-side">
    @if (filterData) {
      <app-filter
        [filterData]="filterData"
        [filterDataInit]="filterDataInit"
        [filterPage]="filterPage"
        (formValus)="filterFormValues($event)"
      >
      </app-filter>
    }
    <div>
      <button class="btn btn-custom-delete" (click)="changeOrderingStatus()">
        <img [src]="orderingState ? 'assets/images/svg/arrow_down_icon_sort.svg' : 'assets/images/svg/arrow_up_icon_sort.svg'" alt="change Ordering Status btn"/>
      </button>
    </div>
    <quick-search [placeholder]="' البحث باسم الخدمة ...'" (searchResults)="quickSearch($event)"></quick-search>
  </div>
  @if(currentUserType === userType.Admin) {
    <div class="new-element">
      <button class="btn btn-add" [routerLink]="['/pages/services/new']">
        <img src="assets/images/svg/add-icon.svg" alt="" />
        إضافة خدمة
      </button>
    </div>
  }
</div>

<div class="custom-card">
  @if (services) {
  <div class="row custom-container">
    @for (service of services | paginate: config; track service; let i = $index)
    {
    <div class="col-6 item">
      <div>
        <label class="checkbox-container">
          <input type="checkbox" />
          <span class="checkmark"></span>
        </label>
        <span class="checkbox-label">
          {{ service.name }} @if (!service.is_active) {
          <span class="inActive">(غير مفعل)</span>
          }
        </span>
        @if(is_sopra && service.owner) {
        <span class="blue-txt"> 
          ({{service?.owner}} @if(service?.inspector_share_type) {- {{service?.inspector_share_type?.name}}})
        </span>
        }
      </div>
      <div class="setting-container">
        @if([userType.Markting, userType.Admin].includes(currentUserType)) {
          <div class="setting-item wrench" title="SEO configuration" (click)="goSEOConfigration(service.id)">
            <img src="assets/images/svg/seo.svg" alt="setting" />
          </div>
        }
        <div class="setting-item wrench" title="website configuration" (click)="goWebsiteConfigration(service.id)">
          <img src="assets/images/svg/configration.svg" alt="setting" />
        </div>
        @if(currentUserType !== userType.Markting) {
          <div class="setting-item wrench" (click)="goServiceSettings(service.id)">
            <img src="assets/images/svg/wrench.svg" alt="setting" />
          </div>
          <div class="setting-item wrench" (click)="goServiceDetails(service.id)">
            <img src="assets/images/svg/edit-icon.svg" alt="" />
          </div>
        }
      </div>
    </div>
    }
  </div>
  } @else {
  <div class="empty-services">لا يوجد خدمات</div>
  }
</div>
@if (services && services.length > 0) {
<ayen-pagination
  (pageData)="pageChanged($event)"
  (pageSize)="pageSizeChanged($event)"
  [id]="'dynamicServicePagination'"
  [totalCount]="config.totalItems"
  [itemsPerPage]="config.itemsPerPage"
  (pageChange)="pageChanged($event)"
  [currentPage]="config.currentPage"
>
</ayen-pagination>
}
